import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si on a un hash (#section), essayer de scroller vers l’ancre
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }

    // Sinon, remonter en haut de la fenêtre
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Bonus : si tu utilises un conteneur scrollable interne, tu peux aussi le reset ici :
    const main = document.querySelector("main");
    if (main && "scrollTop" in main) {
      (main as HTMLElement).scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
}
